<template>
    <div class="c-newsletter-ajax">
        <!-- S T A T I C  S P I N N E R -->
        <!--<div id="map-loading-spinner" class="loader-container show" role="alert"
            aria-live="assertive">
            <div class="loader">Loading...</div>
        </div>-->
        <!-- LOADING SPINNNER -->
      <aha-modal
        ref="loadingModal"
        size="md"
        id="loadingModal"
        class="c-loadingModal"
        hide-footer
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        centered
        lazy
      >
        <template slot="modal-header">
          <div class="c-loadingModal__heading">Submitting</div>
        </template>
        <aha-loading-spinner :is-loading="true" />
      </aha-modal>
        <!-- S L O T S -->
        <div v-if="showError" class="alert alert-danger">
            {{errorMsg}}
        </div>
        <transition name="fade" mode="out-in">
            <slot v-if="!toggleShow" name="newsletter" 
            :resetForm="resetForm" 
            :formData="formData"
            :submitForm="submitForm"
            :response="response"
            :toggleShow="toggleShow"
            ></slot>
        
            <slot v-else="" name="thankyou" :toggleShow="toggleShow"></slot>
        </transition>

    </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import ahaLoadingSpinner from "./aha-loading-spinner.vue";
export default {
    name: 'NewsletterAjax',
    components: {
        "aha-loading-spinner": ahaLoadingSpinner,
    },
    props: {
        url: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            formData: {},
            response: {},
            toggleShow: false,
            loading: false,
            showError: false,
            errorMsg: ''
        }
    },
    methods: {
        submitForm(evt) {
            evt.preventDefault();
            this.loading = true;
            this.showLoadingModal();
            
            axios({
                method: 'POST',
                url: this.url,
                responseType: 'json',
                data: this.formData
            }).then(response => {
                // console.log('RESPONSE', response.data);
                // on success slide in the thank you slide
                if(response.data === null) {
                    //
                } else {
                    //this.response = response.data;
                    //console.log('RESPONSE', response.data);
                    this.response = response.data;
                    this.toggleShow = response.data.success;
                    if(this.showError === true) {
                        this.resetError();
                    }
                    this.hideLoadingModal(1000);
                    this.loading = false;
                    
                }
                //this.loading = false;
            }).catch(error => {
                console.log('ERROR ERROR ERROR ERROR ');
                console.log(error);
                this.hideLoadingModal(1000);
                // without timeout the error will show instantly, 
                // give some time for the modal to display
                setTimeout(() => {
                    this.showError = true;
                    this.errorMsg = error;
                    this.loading = false;
                }, 1000);
            })
        },
        resetForm(evt) {
                this.formData = {};
                // this.EventBus.$emit('stepTrigger', 1);
                // inputEventBus.$emit('inputCleared');
                console.log('reset form is called')

        },
        showLoadingModal() {
             this.$root.$emit("bv::show::modal", "loadingModal");
        },
        hideLoadingModal(val) {
            setTimeout(() => {
                this.$root.$emit("bv::hide::modal", "loadingModal");
            }, val);
        },
        resetError() {
            this.showError = false;
            this.errorMsg = '';
        }
    },
    mounted() {
    console.log('THIS: ', this);
    console.log('SCOPEDSLOTS', this.$scopedSlots);   
    console.log('REFS', this.$refs);   





    }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: .5;
}


</style> 


// WEBPACK FOOTER //
// src/app/components/aha-newsletter-ajax-thank-you.vue